var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.92-215h60v-40h50q12.77 0 21.39-8.62 8.61-8.61 8.61-21.38v-120q0-12.77-8.61-21.38-8.62-8.62-21.39-8.62h-130v-60h160v-60h-80v-40h-60v40h-50q-12.77 0-21.38 8.62-8.62 8.61-8.62 21.38v120q0 12.77 8.62 21.38 8.61 8.62 21.38 8.62h130v60h-160v60h80v40ZM252.31-100Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-644.62V-800H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-472.31H540ZM240-800v155.38V-800-160v-640Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing_icon.74db7419dc8f9e091ffad24002f094c8.svg";
export { ForwardRef as ReactComponent };